import { AuthService } from "../../auth/services/auth.service";
import { UserAccess } from '../../auth/models/auth-infos'

export class PermissionService {
  constructor(private authService:AuthService) {}
  hasFullAccess(_entity?: string, _id?: string): boolean {
    if (!this.authService.authInfos) {
      return false
    }
    return this.authService.authInfos?.userAccess !== UserAccess.Free
  }
}

// export const permissionService = new PermissionService()